import type { ReactNode } from 'react';

import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'primary' | 'accent' | 'success' | 'warning' | 'error' | 'info';

export interface BadgeProps {
  readonly tone?: BadgeTone;
  /** Adds a leading dot. Reinforcement only — the label still carries meaning. */
  readonly withDot?: boolean;
  readonly children: ReactNode;
}

/**
 * Status or category chip — design addon §8.4.
 *
 * There is deliberately no icon-only or dot-only mode: a status a reader can
 * only decode from hue violates §4.2.
 */
export function Badge({ tone = 'neutral', withDot = false, children }: BadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {withDot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
